<template>
  <v-container class="py-12">
    <TitleHeader>Acesso Remoto</TitleHeader>

    <div class="support-page">
      <section
        v-for="section in supportSections"
        :key="section.title"
        class="support-section"
      >
        <div class="section-heading">
          <v-icon
            size="30"
            class="section-icon"
          >
            {{ section.icon }}
          </v-icon>
          <h2>{{ section.title }}</h2>
        </div>

        <v-row
          dense
          class="support-grid"
        >
          <v-col
            v-for="item in section.items"
            :key="item.title"
            cols="12"
            md="6"
          >
            <v-card class="support-card">
              <div class="support-card__content">
                <div>
                  <span class="support-card__label">{{ item.label }}</span>
                  <h3>{{ item.title }}</h3>
                </div>

                <v-btn
                  :href="item.href"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="primary"
                  variant="flat"
                  class="support-card__button"
                >
                  <v-icon start>mdi-download</v-icon>
                  Baixar
                </v-btn>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </div>
  </v-container>
</template>

<script setup lang="ts">
import TitleHeader from '@/components/TitleHeader.vue'

definePageMeta({
  middleware: 'manutencao',
  title: 'FUNARPEN - Acesso Remoto',
})

useHead({
  title: 'Acesso Remoto - FUNARPEN',
  meta: [{ name: 'description', content: 'Download de acesso remoto da FUNARPEN.' }],
})

const supportSections = [
  {
    title: 'TEAMVIEWER',
    icon: 'mdi-remote-desktop',
    items: [
      {
        label: 'TEAMVIEWER (CLIENTE)',
        title: 'TeamViewer',
        href: 'https://funarpen.com.br/aplicativos/TeamViewer14.zip',
      },
    ],
  },
]
</script>

<style scoped>
.support-page {
  display: grid;
  gap: clamp(28px, 4vw, 44px);
}

.support-section {
  display: grid;
  gap: 18px;
}

.section-heading {
  display: flex;
  align-items: center;
  gap: 12px;
  color: var(--funarpen-navy);
}

.section-heading h2 {
  margin: 0;
  font-size: clamp(1.15rem, 2vw, 1.45rem);
  font-weight: 900;
  line-height: 1.2;
  letter-spacing: 0;
}

.section-icon {
  flex: 0 0 auto;
  color: var(--funarpen-gold);
}

.support-grid {
  row-gap: 16px;
}

.support-card {
  height: 100%;
  border: 1px solid rgba(8, 47, 73, 0.12);
  border-radius: var(--funarpen-radius) !important;
  background:
    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 251, 253, 0.94)),
    #fff !important;
  box-shadow: var(--funarpen-shadow-soft) !important;
}

.support-card__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  min-height: 142px;
  padding: 24px;
}

.support-card__label {
  display: block;
  margin-bottom: 8px;
  color: var(--funarpen-blue);
  font-size: 0.78rem;
  font-weight: 900;
  line-height: 1.25;
  text-transform: uppercase;
}

.support-card h3 {
  margin: 0;
  color: var(--funarpen-ink);
  font-size: clamp(1rem, 1.6vw, 1.2rem);
  font-weight: 900;
  line-height: 1.25;
  letter-spacing: 0;
}

.support-card__button {
  flex: 0 0 auto;
  min-width: 128px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 600px) {
  .support-card__content {
    align-items: flex-start;
    flex-direction: column;
    min-height: 168px;
    padding: 20px;
  }

  .support-card__button {
    width: 100%;
  }
}
</style>
